import ModalTypes from 'aria-viewer/modal/constants/ModalTypes'
import ModalContentTypes from 'aria-viewer/modal/constants/ModalContentTypes'
import ModalActions from 'aria-viewer/modal/modalActions'
import RegistrationPageContexts from 'aria-viewer/registration/RegistrationPageContexts'
import ModalSources from 'aria-viewer/modal/constants/ModalSources'
import { setRegistrationPageContext, openRegistrationModal } from 'aria-viewer/registration/registrationActions'

export const OPEN_CTA_PROMPT = 'CTAPrompt.OPEN_CTA_PROMPT'
export const CLOSE_CTA_PROMPT = 'CTAPrompt.CLOSE_CTA_PROMPT'

export const openCTAPrompt = ({ promptType, isModal = true }) => (dispatch, getState) => {
    const batchedActions = []

    if (isModal) {
        // open a fullscreen modal
        batchedActions.push(
            ModalActions.openModal(ModalTypes.FULLSCREEN, {
                contentType: ModalContentTypes.CTA_PROMPT,
            })
        )
    }

    // and then record that as a CTA Prompt in our state
    batchedActions.push({
        type: OPEN_CTA_PROMPT,
        isModalCTAPrompt: isModal,
        promptType,
    })

    // and finally fire them as a batched update
    dispatch(batchedActions)
}

export const closeCTAPrompt = ({ isModal = true }) => (dispatch, getState) => {
    const batchedActions = []

    // first close the modal representing the CTA Prompt
    if (isModal) {
        batchedActions.push(ModalActions.closeModal())
    }

    // then signal that cta prompt is no longer open
    batchedActions.push({ type: CLOSE_CTA_PROMPT })

    // and finally fire them as a batched update
    dispatch(batchedActions)
}

export const beginRegistrationFromCTA = ({ ctaPromptIsModal }) => (dispatch, getState) => {
    const batchedActions = []
    if (ctaPromptIsModal) {
        batchedActions.push(ModalActions.closeModal())
    }
    batchedActions.push({ type: CLOSE_CTA_PROMPT })
    batchedActions.push(setRegistrationPageContext(RegistrationPageContexts.MOBILE_LANDING))
    batchedActions.push(openRegistrationModal(ModalSources.CTA_BUTTON_CLICKED))
    dispatch(batchedActions)
}

export default {
    openCTAPrompt,
    closeCTAPrompt,
    OPEN_CTA_PROMPT,
    CLOSE_CTA_PROMPT,
}
